(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-progress-bar"] && !Shopify.designMode) return;
  try {
    class FreeShippingProgressBar extends HTMLElement {
    connectedCallback() {
      this.fillEl = this.querySelector('.fsb__fill');
      this.messageEl = this.querySelector('.fsb__message');
      this.trackEl = this.querySelector('.fsb__track');
      this.threshold = parseFloat(this.dataset.threshold);
      this.remainingTemplate = this.dataset.remainingTemplate || '';
      this.qualifiedText = this.dataset.qualifiedText || '';
      this.locale = this.dataset.locale || document.documentElement.lang || 'en';

      const eventName =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';

      if (typeof subscribe === 'function') {
        this.unsubscribe = subscribe(eventName, this.onCartUpdate.bind(this));
      }

      this.refresh();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    onCartUpdate(event) {
      const data = event && event.cartData;
      if (data && typeof data.items_subtotal_price === 'number' && data.currency) {
        this.render(data.items_subtotal_price, data.currency);
      } else {
        this.refresh();
      }
    }

    refresh() {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(`${cartUrl}.js`)
        .then((response) => response.json())
        .then((cart) => this.render(cart.items_subtotal_price, cart.currency))
        .catch(() => {});
    }

    render(subtotalSubunits, currency) {
      if (!this.threshold || this.threshold <= 0) return;

      const formatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: currency,
      });
      const decimals = formatter.resolvedOptions().maximumFractionDigits;
      const factor = Math.pow(10, decimals);
      const current = subtotalSubunits / factor;
      const remaining = this.threshold - current;
      const percent = Math.min(100, Math.max(0, (current / this.threshold) * 100));

      this.style.setProperty('--fsb-progress', `${percent}%`);
      if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', Math.round(percent));

      if (remaining <= 0) {
        this.classList.add('fsb--qualified');
        this.messageEl.textContent = this.qualifiedText;
      } else {
        this.classList.remove('fsb--qualified');
        this.messageEl.innerHTML = this.remainingTemplate.replace('__AMOUNT__', formatter.format(remaining));
      }
    }
  }

  if (!customElements.get('free-shipping-progress-bar')) {
    customElements.define('free-shipping-progress-bar', FreeShippingProgressBar);
  }
  } catch(e) { console.error(e); }
})();

})();
